// extracted by css-extract-rspack-plugin
export default {"card":"card--IB1YgBoq6NUGV9fy","header":"header--mldNvHY1kkRm55wS"};